import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23615c9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=23615c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23615c9c",
  null
  
)

export default component.exports